export default "__VITE_ASSET__BpEY669k__"